import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { SelectorIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
const langue = [
  {
    id: 1,
    name: "Français",
    shortCut: "de",
    avatar: "/flag/france_flag.png",
  },
  {
    id: 2,
    name: "English",
    shortCut: "en",
    avatar: "/flag/britain_flag.png",
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Languageselect() {
  const [selected, setSelected] = useState(langue[0]);
  const { i18n } = useTranslation("common");
  function changeLanguage(lng) {
    localStorage.setItem("langue", lng);
    // props.toggle();
    i18n.changeLanguage(lng);
  }

  return (
    <Listbox
      value={selected}
      onChange={(e) => {
        setSelected(e);

        changeLanguage(e.shortCut);
      }}
    >
      {({ open }) => (
        <>
          {/* <Listbox.Label className="text-sm font-medium text-gray-700"></Listbox.Label> */}
          <div className="mt-1 absolute ">
            <Listbox.Button className="ml-1 absolute mb-1 w-40 bg-white border dark:bg-gray-700 border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 sm:text-sm">
              <span className="flex items-center">
                <img
                  src={selected.avatar}
                  alt=""
                  className="flex-shrink-0 h-6 w-6 rounded-full"
                />
                <span className="ml-3 block truncate dark:text-white">
                  {selected.name}
                </span>
              </span>
              <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                <SelectorIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="ml-1  relative z-10 mt-12  w-44 bg-white dark:bg-gray-700 shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                {langue.map((lng) => (
                  <Listbox.Option
                    key={lng.id}
                    className={({ active }) =>
                      classNames(
                        active ? "text-white bg-green-500" : "text-gray-900",
                        "cursor-default select-none relative py-2 pl-3 pr-9"
                      )
                    }
                    value={lng}
                  >
                    {({ selected, active }) => (
                      <>
                        <div className="flex items-center">
                          <img
                            src={lng.avatar}
                            alt=""
                            className="flex-shrink-0 h-6 w-6 rounded-full"
                          />
                          <span
                            className={classNames(
                              selected ? "font-semibold" : "font-normal",
                              "ml-3 block truncate dark:text-white"
                            )}
                          >
                            {lng.name}
                          </span>
                        </div>

                        {/* {selected ? (
                          <span
                            className={classNames(
                              active ? "text-white" : "text-indigo-600",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null} */}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  );
}
